import { RouteComponentProps } from '@reach/router';
import { AppPath } from 'appConstants';
import SignInForm from 'components/signInForm/SignInForm';
import {
  MFA_CHALLENGE_AREA,
  storeMfaReturnUrl,
} from 'helpers/mfa/mfaReturnUrl';
import { useDefaultRoute } from 'hooks/useDefaultRoute';
import React from 'react';
import Page from '../components/shared/Page';

export const SignIn: React.FC<RouteComponentProps> = () => {
  useDefaultRoute(AppPath.SIGN_IN);

  const params = new URLSearchParams(window.location.search);
  const getURLArea = params.get('area');
  const returnUrl = params.get('redirectURL');

  // Stored during render: when already signed in, Page redirects before an effect would run.
  if (getURLArea === MFA_CHALLENGE_AREA && returnUrl) {
    storeMfaReturnUrl(returnUrl);
  }

  return (
    <Page isPublic redirectPath={getURLArea ? getURLArea : ''}>
      <div className="SignInPage">
        <div className="Content HeightContent">
          <SignInForm />
        </div>
      </div>
    </Page>
  );
};
